import { fetchUtils } from 'react-admin'
import jsonServerProvider from 'ra-data-json-server';

const httpClient = (url: string, options: any = {}) => {
  const _options = options
  if (_options && !_options.headers) {
    _options.headers = new Headers({ Accept: 'application/json' })
  }
  const idToken = sessionStorage.token;
  _options.headers.set('Authorization', `Bearer ${idToken}`)
  return fetchUtils.fetchJson(url, _options)
}

export class DefaultDataSource {
  constructor() {
    this.dataSource = jsonServerProvider(process.env.REACT_APP_LOCAL_BACK_URI, httpClient)
  }

  getList(resource: string, params: any): Promise<any> {
    return this.dataSource.getList(resource, params)
  }

  getOne(resource: string, params: any): Promise<any> {
    return this.dataSource.getOne(resource, params)
  }

  getMany(resource: string, params: any): Promise<any> {
    return this.dataSource.getMany(resource, params)
  }
    
  getManyReference(resource: string, params: any): Promise<any> {
    return this.dataSource.getManyReference(resource, params)
  }
    
  create(resource: string, params: any): Promise<any> {
    return this.dataSource.create(resource, params)
  }

  update(resource: string, params: any): Promise<any> {
    return this.dataSource.update(resource, params)
  }
  updateMany(resource: string, params: any): Promise<any> {
    return this.dataSource.updateMany(resource, params)
  }

  delete(resource: string, params: any): Promise<any> {
    return this.dataSource.delete(resource, params)
  }

  deleteMany(resource: string, params: any): Promise<any> {
    return this.dataSource.deleteMany(resource, params)
  }

  private dataSource
}
